module.exports = __webpack_public_path__ + "static/Vernon Perry-436b029eddae5056050c6954773ec30c.png";